import { gql } from '@apollo/client';

const ProductInfoShared = gql`
  fragment ProductInfoShared on Product {
    id
    name
    price
    wholesalePrice
    description
    featuredImage
    arches
    isEot
    isRetainer
    productType
    isFreeTrial
    active
  }
`;

export default ProductInfoShared;
